const o=()=>"tk-"+Math.floor(100*Math.random()+1);export{o as generateTrafficKey};
